export default "__VITE_ASSET__Xg6DgMpQ__"